import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Card } from 'antd';
import { PageLayout } from '../../components/PageLayout/PageLayout';
import './TermsOfServicePage.css';

const TermsOfServicePage = () => {
    const [markdown, setMarkdown] = useState('');

    useEffect(() => {
        fetch(require('./TERMS_OF_SERVICE.md'))
            .then(response => response.text())
            .then(text => setMarkdown(text))
            .catch(error => console.error('Error loading terms of service:', error));
    }, []);

    return (
        <PageLayout fullWidth>
            <Card
                variant="outlined"
                className="markdown-container terms-of-service-card"
                style={{
                    border: '2px solid #7a7a7a',
                }}
            >
                <ReactMarkdown>{markdown}</ReactMarkdown>
            </Card>
        </PageLayout>
    );
}

export default TermsOfServicePage;
